import React, {
  type SyntheticEvent,
  type ForwardedRef,
  type PropsWithChildren,
} from "react";

import { type Table } from "@devexpress/dx-react-grid-bootstrap4";

interface Props extends PropsWithChildren<Table.DataCellProps> {
  forwardedRef?: ForwardedRef<HTMLTableCellElement>;
  onClick?: (event: SyntheticEvent) => void;
  onBlur?: (event: SyntheticEvent) => void;
}

export const TableCell = ({
  column,
  value,
  children,
  tableRow,
  tableColumn,
  row,
  onClick,
  onBlur,
  forwardedRef,
  ...restProps
}: Props) => {
  let cellValue = children || value;
  if (
    cellValue === undefined ||
    cellValue === null ||
    Number.isNaN(cellValue)
  ) {
    cellValue = "";
  }

  return (
    <td ref={forwardedRef} {...restProps} onClick={onClick}>
      {cellValue}
    </td>
  );
};
